import { RootState } from '@/lib/store';
import { Restriction } from '@/models/restriction';
import { Nullable } from '@starsoft/common/interfaces';
import { useSelector } from 'react-redux';
import RestrictionDetailsModalRestrictions from '../Restrictions';
import RestrictionDetailsModalUnreachableRestriction from '../Unreacheble';
import { memo } from 'react';

function RestrictionDetailsModalRenderer() {
  return <RestrictionDetailsModalRestrictions />;
}

export default memo(RestrictionDetailsModalRenderer);
